module.exports = __webpack_public_path__ + "img/calendar.81f76f6e.svg";